import DevicesDeactivate from './DevicesDeactivate'

export default DevicesDeactivate
